import { Badge } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import styles from '../nav.module.scss'
import { FETCH_NOTIFICATIONS } from 'modules/Recommendations/Audits/store/types'
import pick from 'lodash/pick'

const REFRESH_COUNTER_TIMEOUT = 600000

const RecommendationMain = (props) => {
  const dispatch = useDispatch()
  const { recommendation = 0, audit = 0, benchmark = 0 } = useSelector(
    (state) => ({
      recommendation: state.notifications?.counters?.recommendation,
      audit: state.notifications?.counters?.audit,
      benchmark: state.notifications?.counters?.benchmark,
    }),
    shallowEqual,
  )

  const getCounters = useCallback(() => dispatch({ type: FETCH_NOTIFICATIONS }), [])

  useEffect(() => {
    let timer = setInterval(getCounters, REFRESH_COUNTER_TIMEOUT)

    return () => clearInterval(timer)
  }, [])

  useEffect(() => {
    if (!recommendation || !audit || !benchmark) {
      getCounters()
    }
  }, [])

  const summary = useMemo(
    () => recommendation + audit + benchmark,
    [recommendation, audit, benchmark],
  )

  const openerProps = useMemo(() => pick(props, ['className', 'onClick', 'title']), [props])

  return (
    <div {...openerProps}>
      {props.children}
      {summary !== 0 && (
        <Badge
          className={styles['nav__link-badge']}
          bgColor={'Accent-Error-Primary'}
          color={'Label-Onsurface'}
        >
          {summary}
        </Badge>
      )}
    </div>
  )
}
export default RecommendationMain

RecommendationMain.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
}
